import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";
import {
  Modal,
  InputGroup,
  FormControl,
  ListGroup,
  Button,
} from "react-bootstrap";
import axios from "axios";
import { LiaSearchSolid } from "react-icons/lia";

const CategoryModal = ({
  showModal,
  closeModal,
  onCategorySelect,
  onDoctorSearch,
}) => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("specialization"); // default tab

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/specialist/categories`
        );
        setCategories(response.data.payLoad);
        setFilteredCategories(response.data.payLoad);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (activeTab === "specialization") {
      const filtered = categories.filter((category) =>
        category.Description.toLowerCase().includes(value.toLowerCase())
      );

      const matchedCategories = filtered.sort(
        (a, b) =>
          a.Description.toLowerCase().indexOf(value.toLowerCase()) -
          b.Description.toLowerCase().indexOf(value.toLowerCase())
      );

      setFilteredCategories(matchedCategories);
    }

    // For "doctor", you can implement doctor search logic here
  };

  const handleCategoryClick = (category) => {
    onCategorySelect(category);
  };
  const handleDoctorSearch = () => {
    onDoctorSearch(searchTerm);
    setActiveTab("specialization");
    setSearchTerm("");
    closeModal();
  };
  return (
    <Modal show={showModal} onHide={closeModal}>
      <Modal.Header>
        <Modal.Title>Select a Category</Modal.Title>
        <button
          type="button"
          onClick={closeModal}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "#ff4d4f",
            position: "absolute",
            right: "16px",
            top: "16px",
            cursor: "pointer",
            lineHeight: "1",
          }}
          aria-label="Close"
        >
          &times;
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* Tabs */}
        <div
          defaultActiveKey="specialization"
          className="d-flex gap-3 align-items-center"
        >
          <Button
            className={`flex-fill ${
              activeTab === "specialization"
                ? "btn-primary"
                : "bg-light text-dark shadow-lg border"
            }`}
            onClick={() => setActiveTab("specialization")}
          >
            Search by Specialization
          </Button>
          <Button
            className={`flex-fill shadow-lg ${
              activeTab === "doctor"
                ? "btn-primary"
                : "bg-light text-dark shadow-sm border"
            }`}
            onClick={() => setActiveTab("doctor")}
          >
            Search by Doctor
          </Button>
        </div>

        {/* Search input */}
        {activeTab === "specialization" ? (
          <InputGroup className="my-3">
            <FormControl
              className="custom-border-ir"
              placeholder="Search Categories"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </InputGroup>
        ) : (
          // <InputGroup className="my-3">
          //   <FormControl
          //     className="custom-border-ir"
          //     placeholder="Search by Doctor's name"
          //     value={searchTerm}
          //     onChange={(e) => setSearchTerm(e.target.value)}
          //   />
          //   <Button
          //     variant="outline-primary"
          //     id="button-search"
          //     onClick={() => {
          //       // Your search logic here
          //       console.log("Search doctor:", searchTerm);
          //     }}
          //   >
          //     Search
          //   </Button>
          // </InputGroup>
          <div
            className="my-3 d-flex justify-content-between rounded"
            style={{ outline: "1px solid", outlineColor: "#50c4cc" }}
          >
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by Doctor's name "
              className="flex-fill px-4 py-2"
              style={{ border: "none", outline: "none" }}
            />
            <button
              onClick={handleDoctorSearch}
              className="text-white px-3 d-flex gap-1 align-items-center rounded-0 py-2"
            >
              <LiaSearchSolid size={20} className="mt-1" />
              Search
            </button>
          </div>
        )}

        {/* Conditional content */}
        {activeTab === "specialization" && (
          <ListGroup>
            {filteredCategories.map((category) => (
              <ListGroup.Item
                key={category.id}
                action
                onClick={() => handleCategoryClick(category)}
                style={{
                  color: "#212529",
                  backgroundColor: "#f8f9fa",
                  cursor: "pointer",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  marginBottom: "8px",
                  padding: "14px 18px",
                  fontWeight: "500",
                  transition: "background 0.2s, color 0.2s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#e6f7ff";
                  e.currentTarget.style.color = "#1890ff";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#f8f9fa";
                  e.currentTarget.style.color = "#212529";
                }}
              >
                {category.Description}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CategoryModal;
